module.exports = __webpack_public_path__ + "static/media/book-content.ae8a6b2f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/book-content.svg
// module id = 103
// module chunks = 0